import React, { useEffect, useState } from 'react';
import "../Css/SuccessPage.css";
import { PiSealCheckFill } from "react-icons/pi";
import { useCartContext } from '../context/addToCart';
import { Link, useParams } from 'react-router-dom';
import deliverymanriding from "../Images/delivery-man-riding.png";
import { get } from '../services/ApiRouting';
import moment from 'moment';
import axios from 'axios';
import { useNavigate } from "react-router-dom";

const SuccessPage = () => {
    const { cartValue, setCartCount, setCartValue } = useCartContext();
    const profileData = JSON.parse(localStorage.getItem('profile'));
    const { orderId } = useParams();
    const navigate = useNavigate();
    const [orderProduct, setOrderProduct] = useState(null);
    const [mainProductData, setMainProductData] = useState(null)
    const [address, setAddress] = useState(null)
    const [hasCreatedShipping, setHasCreatedShipping] = useState(false);
    const fetchData = async () => {
        try {
            // const response = await get(`orders.php?action=fetch&orderId=${orderId}&admin_token=OdRLLsX46k3L8EwZgpNlVK5tKiRaghecPNH&limit=10&page=1&user_id=${profileData.user_id}`);
            const response = await axios.get(`https://api.woodsy.co.in/api/wood-orders/fetch?order_id=${orderId}`);
            console.log("response", response?.data?.orders[0])
            setMainProductData(response?.data?.orders[0])
            // setAddress(response.orders[0].address)
            setOrderProduct(response?.data?.orders[0].products);
            console.log("responce", response)
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [orderId]);

    const roundedBasePrice = Math.round(mainProductData?.subtotal / 1.18);
    const totaltax = Math.round(mainProductData?.subtotal - roundedBasePrice);

    useEffect(() => {
        if (
            !hasCreatedShipping &&
            orderProduct &&
            orderProduct.length == 1 &&
            orderProduct[0]?.product_qty <= 1
        ) {
            const createShippingAndUpdateOrder = async () => {
                try {
                    const currentDate = new Date();
                    const epochTimestamp = `/Date(${currentDate.getTime()})/`;

                    const commonEmail = mainProductData?.user?.user_email;
                    const commonPhone = mainProductData?.user?.user_phone;
                    const commonPincode = mainProductData?.address?.pincode;

                    const requestData = {
                        action: "generateWaybill",
                        ConsigneeAttention: mainProductData?.user?.user_name,
                        ConsigneeEmailID: commonEmail,
                        ConsigneeMobile: commonPhone,
                        ConsigneePincode: commonPincode,
                        ReturnEmailID: commonEmail,
                        ReturnMobile: commonPhone,
                        ReturnPincode: commonPincode,
                        PickupDate: epochTimestamp,
                        CustomerEmailID: commonEmail,
                        CustomerMobile: commonPhone,
                        CustomerPincode: commonPincode,
                        Breadth: orderProduct?.[0]?.details?.Breadth,
                        Count: "1",
                        Height: orderProduct?.[0]?.details?.Height,
                        Length: orderProduct?.[0]?.details?.Length
                    };

                    console.log("Request Data:", JSON.stringify(requestData, null, 2));

                    const response = await axios.post(
                        "https://Woodsy.in/api/newblue.php",
                        requestData,
                        { headers: { "Content-Type": "application/json" } }
                    );

                    if (response.status >= 200 && response.status <= 300) {
                        console.log("Shipping created successfully", response.data);

                        const trackingId = response.data?.response?.GenerateWayBillResult?.AWBNo;
                        console.log("order_id", mainProductData.order_id)
                        if (!trackingId && mainProductData.order_id) {
                            console.error("Tracking ID not found in response");
                            return;
                        }

                        const formData = new FormData();
                        formData.append("action", "update");
                        formData.append("order_id", mainProductData?.order_id);
                        formData.append("tracking_id", trackingId);
                        formData.append("admin_token", "OdRLLsX46k3L8EwZgpNlVK5tKiRaghecPNH");

                        const updateResponse = await axios.post(
                            "https://Woodsy.in/api/orders.php",
                            formData,
                            { headers: { "Content-Type": "multipart/form-data" } }
                        );

                        if (updateResponse.status >= 200 && updateResponse.status <= 300) {
                            console.log("Order updated successfully with tracking ID", updateResponse.data);
                        } else {
                            console.error("Failed to update order", updateResponse.data);
                        }
                        setHasCreatedShipping(true);
                        // setShippingModalVisible(false);
                        // shippingForm.resetFields();
                    } else {
                        console.error("Failed to create shipping", response.data);
                    }
                } catch (error) {
                    console.error("Error creating shipping or updating order", error);
                }
            };

            createShippingAndUpdateOrder();
        }
    }, [orderProduct]);

    console.log("mainProductData", mainProductData)

    return (
        <>
            <section className='SuccessPage-Section-con'>
                <div className='container'>
                    <div className='SuccessPage-Section'>
                        <div className='SuccessPage-Section-Details-con'>
                            <div className='order-Success-con'>
                                <div className='order-Success-con-icons'>
                                    <PiSealCheckFill />
                                    <h2>Order Confirmed</h2>
                                    <p>Thank you for shopping with Woodsy! We're excited to let you know that your order has been successfully confirmed. Our team is hard at work preparing your items with the utmost care. We appreciate your trust in us and can't wait for you to enjoy your purchase. Thanks for choosing Woodsy, where quality and satisfaction are our top priorities.</p>
                                </div>
                                <div className='Order-Success-Details-con-Main'>
                                    <div className='Order-Success-Details-con-Main-head'>
                                        <div className='Order-Success-List-head'>
                                            <h3>Order Id : - <span>{mainProductData?.order_id}</span></h3>
                                        </div>
                                        <div className='Order-Success-List-head'>
                                            <h3>Ordered on : - <span>{moment(mainProductData?.created_at).format("MMMM D, YYYY h:mm:ss A")}</span></h3>
                                        </div>
                                    </div>
                                    <div className='Order-Success-Details-con'>
                                        <div className='Order-Success-Details-add'>
                                            <h1>delivering to :</h1>
                                            <div className='Order-Success-Details-name-contact'>
                                                <h2>
                                                    {mainProductData && mainProductData?.address?.city}
                                                </h2>
                                                <span>
                                                    |
                                                </span>
                                                <h2>
                                                    {address && mainProductData?.address?.alternative_number}
                                                </h2>
                                            </div>
                                            <div className='Order-Success-Details-address'>
                                                <p>{mainProductData?.address?.address}, {mainProductData?.address?.city}, {mainProductData?.address?.state}, {mainProductData?.address?.pincode}</p>
                                            </div>
                                        </div>
                                        <div className='Order-Success-Details-Image-con'>
                                            <img src={deliverymanriding} alt="" />
                                        </div>
                                    </div>
                                </div>

                                <div className='Order-Success-List-con'>
                                    <div className="Order-Success-List">
                                        <div className='Product-addedCart-Side-Bar Successpage-Product-addedCart-Side-Bar' id="style-4">
                                            {
                                                orderProduct && orderProduct.map((elem, index) => {
                                                    const { details, images, size, price, qty, main_category, brand, sub_category, product } = elem
                                                    console.log("product",product)
                                                    return (
                                                        <div key={index} className='Product-addedCart-Side-details'>
                                                            <div className='Product-addedCart-Image-con'>
                                                                <div className='Product-addedCart-Image'>
                                                                    {product?.images && product?.images && (
                                                                        <img src={`https://api.woodsy.co.in/storage/${product?.images[1]?.image1}`} alt={brand?.name} />
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className='Product-details-addedCart-price-name SuccessPageprice'>
                                                                <div className='Product-details-addedCart-price'>
                                                                    <h2>{brand?.name}</h2>
                                                                    <h2>{main_category?.name}</h2>
                                                                    <h2>{sub_category?.name}</h2>
                                                                    <h3>Qty: <span>{qty}</span></h3>
                                                                    <h3>Price: <span>{price}</span></h3>
                                                                    <h3>Size: <span>{size}</span></h3>
                                                                </div>
                                                                <h2>{price}/- Rs</h2>
                                                            </div>
                                                        </div>
                                                    );
                                                })
                                            }
                                        </div>
                                        <div className='Product-details-Addedcart-total-con'>
                                            <div className='Product-details-Addedcart-total order-successpage-product-detail-final'>
                                                <div className='Product-details-Addedcart-total-title'>
                                                    <h4>Subtotal:</h4>
                                                    <h4>Tax (18%):</h4>
                                                    {/* <h4>BasePrice:</h4> */}
                                                    <h4>Total:</h4>
                                                </div>
                                                <div className='Product-details-Addedcart-total-Amount'>
                                                    <h5>{mainProductData?.gross_amount} /- Rs</h5>
                                                    <h5>{mainProductData?.tax_amount} /- Rs</h5>
                                                    <h5>{mainProductData?.total_amount} /- Rs</h5>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='order-success-page-btn-con'>
                                            <Link to="/">
                                                <button>
                                                    Back to home
                                                </button>
                                            </Link>
                                            <Link to="/product">
                                                <button>
                                                    Continue Shopping
                                                </button>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default SuccessPage;
